export const uncapitalizeFirstLetter =(text) => text && text[0].toLowerCase() + text.slice(1) || text;
